import { withStyles } from '@material-ui/core';
import { Col, Grid, Row } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { submit } from 'redux-form';
import moment from 'moment';
import InsertEmailOTPForm from '../../components/forms/LoginForm/EmailOTPLogin/InsertEmailOTPForm.jsx';
import InsertOTPEmailForm from '../../components/forms/LoginForm/EmailOTPLogin/InsertOTPEmailForm.jsx';
import MDButton from '../../components/MDButton/MDButton.jsx';
import * as ModalsActions from '../../redux/actions/modal.actions';
import * as UserActions from '../../redux/actions/user.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import { GREEN, ORANGE } from '../../_config/consts.js';
import { getLuckeyLogoSource, isMobileBrowser } from '../../_config/utils';
import { push } from 'react-router-redux';

const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    overflow: 'hidden',
    backgroundColor: '#f5f5f5',
  },
  leftPanel: {
    flex: 1,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '0 80px',
    backgroundColor: '#157495',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to right, rgba(21, 116, 149, 0.7), rgba(21, 116, 149, 0.7))',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      width: '40px',
      height: '100%',
      background: 'linear-gradient(to right, rgba(21, 116, 149, 0), rgba(245, 245, 245, 0.2))',
      zIndex: 2,
    }
  },
  leftPanelContent: {
    position: 'relative',
    zIndex: 1,
    color: 'white',
    width: '100%',
    '& img': {
      maxWidth: '100%',
      height: 'auto'
    },
    '& *': {
      color: 'white !important'
    }
  },
  rightPanel: {
    flex: 1,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    position: 'relative',
    boxShadow: '-12px 0 20px -10px rgba(0, 0, 0, 0.15)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '40px',
      height: '100%',
      background: 'linear-gradient(to right, rgba(0, 0, 0, 0.03), transparent)',
      zIndex: 1,
    }
  },
  mobileContainer: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#157495',
    padding: 20
  },
  formCard: {
    width: '100%',
    maxWidth: 500,
    padding: '20px 40px',
    backgroundColor: props => props.isMobile ? '#157495' : 'white',
    borderRadius: 8,
    boxShadow: props => props.isMobile ? 'none' : '0px 4px 14px rgba(0, 0, 0, 0.1)'
  },
  copyright: {
    position: 'absolute',
    bottom: 20,
    color: '#666',
    fontSize: 12,
    textAlign: 'center',
    width: '100%'
  },
  description: {
    color: 'rgba(255,255,255,0.9)',
    fontSize: 18,
    maxWidth: 500,
    position: 'relative',
    zIndex: 1
  },
});

@withRouter
@connect(state => ({ 
  userData: state.user.data, 
  companyConfigurations: state.user.companyConfigurations,
  loginContent: state.user.loginContent
}))
class LoginEmailOTPView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      otpCodeSent: false,
      isLoadingLogin: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(UserActions.fetchLoginContent());
  }
  
  async onSendOTPEmail(data) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(UserActions.sendOTPEmail(data.email));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ otpCodeSent: true });
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      setTimeout(() => {
        dispatch(ModalsActions.showModal({
          modalType: 'ERROR_MODAL',
          modalProps: { type: 'DEFAULT_ERROR', defaultMessage: <Entity entity="loginJagoOTPEmailFailed" /> },
        }));
      }, 500);
    }
  }

  async onLoginWithOTP(data) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      this.setState({ isLoadingLogin: true });
      await dispatch(UserActions.loginWithOTP(data.code));
      this.setState({ isLoadingLogin: false, otpCodeSent: false });
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ isLoadingLogin: false, otpCodeSent: false });
      dispatch(ModalsActions.showModal({
        modalType: 'ERROR_MODAL',
        modalProps: { type: 'DEFAULT_ERROR', defaultMessage: <Entity entity="loginJagoOTPFailed" /> },
      }));
    }
  }

  onBackToLogin() {
    const { dispatch, companyConfigurations } = this.props;
    const isOtpLoginOnly = companyConfigurations && companyConfigurations.otpLoginOnly;
    dispatch(UserActions.logout());
    this.setState({ otpCodeSent: false });
    if (isOtpLoginOnly) {
      dispatch(push('/loginOTPEmail'));
    } else {
      dispatch(push('/login'));
    }
  }

  renderForm() {
    const { dispatch } = this.props;
    const { otpCodeSent, isLoadingLogin } = this.state;
    if (!otpCodeSent) {
      return (
        <div>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 30 }}>
            <img src="/imgs/common/logoJagoDark.png" alt="Logo" style={{ width: 200, height: 'auto' }} />
          </div>
          <div style={{ marginBottom: 20 }}>
            <h1 style={{ 
              fontSize: 30,
              fontWeight: 600,
              color: '#333',
              marginBottom: 8,
              textAlign: 'center'
            }}>
              <Entity key={otpCodeSent} entity="emailLoginTitle" />
            </h1>
            <p style={{ 
              color: '#666',
              fontSize: 14,
              lineHeight: '1.5',
              textAlign: 'center'
            }}>
              <Entity key={otpCodeSent} entity="emailLoginDescription" />
            </p>
          </div>
          <InsertEmailOTPForm
            onSubmit={codeData => this.onSendOTPEmail(codeData)}
          />
          <MDButton
            title={<Entity entity="confirm" />}
            containerStyle={{ margin: 0, marginTop: 20, marginBottom: 20, width: '100%' }}
            backgroundColor={GREEN}
            onClick={() => dispatch(submit('InsertEmailOTPForm'))}
          />
        </div>
      );
    }

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 30 }}>
          <img src="/imgs/common/logoJagoDark.png" alt="Logo" style={{ width: 200, height: 'auto' }} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <h1 style={{ 
            fontSize: 30,
            fontWeight: 600,
            color: '#333',
            marginBottom: 8,
            textAlign: 'center'
          }}>
            <Entity key={otpCodeSent} entity="verificationCode" />
          </h1>
          <p style={{ 
            color: '#666',
            fontSize: 14,
            lineHeight: '1.5',
            textAlign: 'center'
          }}>
            <Entity key={otpCodeSent} entity="verificationCodeDescription" />
          </p>
        </div>
        <InsertOTPEmailForm
          onSubmit={codeData => this.onLoginWithOTP(codeData)}
        />
        <MDButton
          title={<Entity entity="confirm" />}
          containerStyle={{ margin: 0, marginTop: 20, marginBottom: 20, width: '100%' }}
          backgroundColor={GREEN}
          onClick={() => dispatch(submit('InsertOTPEmailForm'))}
        />
      </div>
    );
  }

  render() {
    const { classes, loginContent, companyConfigurations } = this.props;
    const { otpCodeSent } = this.state;
    const isMobile = isMobileBrowser();
    const loginHtmlContent = loginContent && loginContent.htmlContent;
    const isOtpLoginOnly = companyConfigurations && companyConfigurations.otpLoginOnly;

    if (isMobile) {
      return (
        <div className={classes.mobileContainer}>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            marginBottom: 32 
          }}>
            <img src="/imgs/common/logoJagoDark.png" alt="Logo" style={{ width: 250, height: 'auto' }} />
            <img src="/imgs/common/tagLine.png" alt="SofiaTagline" style={{ height: 13 }} />
          </div>
          <div className={classes.formCard}>
            {this.renderForm()}
            <MDButton
              title={<Entity entity="backToLogin" />}
              backgroundColor={ORANGE}
              containerStyle={{ margin: 0, marginTop: 20, marginBottom: 20, width: '100%' }}
              onClick={() => this.onBackToLogin()}
            />
          </div>
          <div className={classes.copyright} style={{ bottom: 50, marginLeft: 10, marginRight: 10 }}>
            <span style={{ color: 'white', fontSize: 10}}>Sofia part of ISEO© {moment().year()}. All rights reserved. <span style={{ fontSize: 10 }}><a href="https://sofialocks.com/en/privacy-policy/" target="_blank"><Entity entity="privacyPolicy" /></a></span></span>
            <span style={{ color: 'white', fontSize: 10 }}>Sofia SRL - VAT: IT09129330966</span>
          </div>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <div className={classes.leftPanel} style={{ backgroundImage: loginContent && loginContent.featuredImage ? `url(${loginContent.featuredImage})` : 'url(/imgs/common/loginBackground.jpg)' }}>
          {loginHtmlContent ? (
            <div className={classes.leftPanelContent} dangerouslySetInnerHTML={{ __html: loginHtmlContent }} />
          ) : (
            <>
              <div className={classes.description}>
                <img src="/imgs/common/logoJagoWhite.png" alt="Logo" style={{ width: 250, height: 'auto' }} />
                <img src="/imgs/common/tagLine.png" alt="Logo" style={{ width: '100%', height: 'auto', marginTop: 10 }} />
                <p style={{ marginTop: 20 }}><Entity entity="loginDescription" /></p>
              </div>
            </>
          )}
        </div>
        <div className={classes.rightPanel}>
          <div className={classes.formCard}>
            {this.renderForm()}
            {!isOtpLoginOnly || (isOtpLoginOnly && otpCodeSent) ? (
              <MDButton
                title={<Entity entity="backToLogin" />}
                backgroundColor={ORANGE}
                containerStyle={{ margin: 0, marginTop: 20, marginBottom: 20, width: '100%' }}
                onClick={() => this.onBackToLogin()}
              />
            ) : null}
          </div>
          <div className={classes.copyright}>
            <span style={{ fontSize: 10 }}>Luckey Web {process.env.REACT_APP_FRONTEND_VERSION} - Sofia part of ISEO© {moment().year()}. All rights reserved. <span style={{ fontSize: 10 }}><a href="https://sofialocks.com/en/privacy-policy/" target="_blank"><Entity entity="privacyPolicy" /></a></span></span>
            <span style={{ fontSize: 10 }}>Sofia SRL - VAT: IT09129330966</span>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(LoginEmailOTPView);
